import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import { profileSetIsLoadingReducerType, profileSetInputDataReducerType, profileSetAllSalutationsReducerType } from './ProfileConstants';

export const initialState = Map({
  isLoading: false,
  inputData: {
    firstName: '',
    lastName: '',
    jobTitle: '',
    location: '',
    institution: '',
    salutation: '',
  },
  allSalutations: null,
});

const spec = {
  [profileSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [profileSetInputDataReducerType]: (state, action) => {
    const currentData = state.get('inputData');
    const { inputData } = action.payload;
    return state.set('inputData', { ...currentData, ...inputData });
  },
  [profileSetAllSalutationsReducerType]: (state, action) => {
    const { allSalutations } = action.payload;
    return state.set('allSalutations', allSalutations);
  },
};

export default createReducerBySpec(spec, initialState);
